const contents = {
  'customerLogin.login.heading.main': 'Log in to Compliance Portal',
  'customerLogin.login.description': 'All fields are required',
};

export default contents;
